import { useState, useEffect, useRef } from 'react'

const getEvent = (e) => {
  if (e.touches) {
    return e.touches[0]
  }
  return e
}

export const useDrag = (dragRef, deps = [], options) => {
  const [isDragging, setIsDragging] = useState(false)
  const optionsRef = useRef(options)

  useEffect(() => {
    optionsRef.current = options
  })

  useEffect(() => {
    if (isDragging) {
      document.body.style.userSelect = 'none'
      document.body.style.webkitUserSelect = 'none' // for Safari
    } else {
      document.body.style.userSelect = ''
      document.body.style.webkitUserSelect = ''
    }
    return () => {
      document.body.style.userSelect = ''
      document.body.style.webkitUserSelect = ''
    }
  }, [isDragging])

  useEffect(() => {
    const element = dragRef.current
    if (!element) return

    const handlePointerDown = (e) => {
      e.preventDefault()
      setIsDragging(true)
      if (optionsRef.current.onPointerDown) {
        optionsRef.current.onPointerDown(getEvent(e))
      }
    }

    const handlePointerMove = (e) => {
      if (isDragging) {
        e.preventDefault()
      }
      if (optionsRef.current.onPointerMove) {
        optionsRef.current.onPointerMove(getEvent(e))
      }
      if (isDragging && optionsRef.current.onDrag) {
        optionsRef.current.onDrag(getEvent(e))
      }
    }

    const handlePointerUp = (e) => {
      setIsDragging(false)
      if (optionsRef.current.onPointerUp) {
        optionsRef.current.onPointerUp(getEvent(e))
      }
    }

    element.addEventListener('pointerdown', handlePointerDown)
    element.addEventListener('touchstart', handlePointerDown, { passive: true })

    if (isDragging) {
      window.addEventListener('pointermove', handlePointerMove)
      window.addEventListener('touchmove', handlePointerMove, { passive: false })
      window.addEventListener('pointerup', handlePointerUp)
      window.addEventListener('touchend', handlePointerUp)
    }

    return () => {
      element.removeEventListener('pointerdown', handlePointerDown)
      element.removeEventListener('touchstart', handlePointerDown)
      window.removeEventListener('pointermove', handlePointerMove)
      window.removeEventListener('touchmove', handlePointerMove)
      window.removeEventListener('pointerup', handlePointerUp)
      window.removeEventListener('touchend', handlePointerUp)
    }
  }, [dragRef, isDragging])

  return [dragRef, isDragging]
}
